import React, { useEffect, useState } from 'react';
import Moment from 'moment';
import { Card } from '../../../../Common/fCards';
import Empty from '../../../../Common/fCard/Empty';
import { get } from '../../../../../Model/Network/Config/Axios';
import { useParams } from 'react-router-dom';
import { Title as Header } from "../../../../Header/TopHeader";
import { GinView } from '../../GateInwardNote/GinView';

const GIN = () => {

    const [ginItem, setGinItem] = useState([]);
    const [open, setOpen] = useState(false);
    let { id } = useParams();
    useEffect(() => {
        next();
    }, [])
    const next = () => {
        get(`/vendor/procurement/gin/getByPoId?po_id=${id}`, (e, r) => {
            if (r) {
                setGinItem(r.vendorGins||[])
            }
        })
    }

    let mapCard = (item, index) => {
        return (
            <Card
                key={`GIN-${index}`}
                flag={{ value: item.status, color: item.status === 'COMPLETED' ? '#198754' : '#6f42c1' }}
                headings={[item.name]}
                details={[
                   ...(item.asn && item.asn.asnId ?[{ label: 'ASN Number', value:item.asn.asnId }]:[]),
                    { label: 'GIN', value: item.ginId },
                    { label: 'Created Date', value: Moment(item.createdAt).format(" hh:mm a DD MMM YY") },
                    { label: 'Delivery Date', value: item.deliveryDate ? Moment(item.deliveryDate).format(" hh:mm a DD MMM YY") : '' },
                    { label: 'PO ID', value: item.poId },
                    { label: 'PO Number', value: item.poNo },
                    { label: 'Category', value: item.category }
                ]}
                onClick={() => { setOpen(item.id) }}
            >
            </Card>
        )
    }
    return (
        <div>
            <div style={{ padding: "10px 20px" ,display:'flex',alignItems:'center'}}>
                <Header container={true} id="GIN" title="All GINs"></Header>
            </div>
            {ginItem.length > 0 ?
                <div style={{ marginLeft: 20, display: 'flex', flexWrap: 'wrap' }}>
                    {ginItem.map(mapCard)}
                </div> :
                <div style={{ marginLeft: 20 }}>
                    <Empty />
                </div>
            }
                  {
                open ?
                    <GinView id={open} onReload={() => { next()}} onClose={() => { setOpen(false) }} /> :
                    null
            }

        </div>
    )
}

export default GIN
